// extracted by mini-css-extract-plugin
export default {"wrapperButtons":"GameActions_wrapperButtons__9g4+x","buttonBackground":"GameActions_buttonBackground__DYvAD","fill":"GameActions_fill__UAFaq"};